import axios from "axios";

export const aboutData = () => {
  return axios
    .get("/about_us")
    .then((response) => {
      // console.log(response.data);
      return response;
    });
};